import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const PageTransition = ({ children }) => {
  const location = useLocation();
  const [displayLocation, setDisplayLocation] = useState(location);
  const [transitionStage, setTransitionStage] = useState("fade-in");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (location?.pathname !== displayLocation?.pathname) {
      setTransitionStage("fade-out");
      setIsLoading(true);
    }
  }, [location, displayLocation]);

  const handleAnimationEnd = () => {
    if (transitionStage === "fade-out") {
      setDisplayLocation(location);
      setTransitionStage("fade-in");
      // Brief loading state to show spinner
      setTimeout(() => {
        setIsLoading(false);
      }, 200);
    }
  };

  return (
    <>
      {/* Loading spinner overlay */}
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            zIndex: 9999,
            pointerEvents: "none",
          }}
        >
          <div
            style={{
              width: "44px",
              height: "44px",
              border: "4px solid #e2e8f0",
              borderTop: "4px solid #0f2044",
              borderRadius: "50%",
              animation: "spin 0.7s linear infinite",
            }}
          />
        </div>
      )}
      {/* Page content with fade transition */}
      <div
        key={displayLocation?.pathname}
        onAnimationEnd={handleAnimationEnd}
        style={{
          animation:
            transitionStage === "fade-in" ?"pageEnter 0.35s ease forwards" :"pageExit 0.2s ease forwards",
        }}
      >
        {children}
      </div>
      <style>{`
        @keyframes pageEnter {
          from {
            opacity: 0;
            transform: translateY(8px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes pageExit {
          from {
            opacity: 1;
            transform: translateY(0);
          }
          to {
            opacity: 0;
            transform: translateY(-8px);
          }
        }

        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </>
  );
};

export default PageTransition;
